export const STATE_PATTERN = /^[a-zA-Z0-9\s]*$/;
export const STATE_MAX_LENGTH = 85;
